<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader class="font-weight-bold padding-sm d-flex justify-content-between catalogo-text">
            <CCol md="6" lg="6" xl="6"> Registrar labores </CCol>
            <CCol md="6" lg="6" xl="6">
              <router-link :to="{ name: 'Labor', params: { config: config } }" class="float-right">
                <CButton color="primary" class="mr-1 btn-header">
                  <CIcon class="mr-1" name="cil-arrow-thick-left" />
                  Regresar
                </CButton>
              </router-link>

              <CButton style="margin-bottom: 10px; height: 35px;" @click="successModalLabor = true" color="primary" class="float-right mr-1 btn-header">
                Limpiar tabla
              </CButton>
            </CCol>
          </CCardHeader>
          <CCardBody style="margin-top: 0px; padding-top: 10px;">
            <CDataTable hover bordered small fixed :loading="errores.length > 0 && errores.length < 20" :items="items" :fields="fields"
              :items-per-page="Number(50)" :noItemsView="noItems">
              <template #COPIAR="{ item }">
                <th style="padding: 10px 5px 5px 5px;" :class="buscarError(item.pos)">
                  <div class="popUp" v-show="item.showpop && errores[item.pos]">
                    <span>{{mensajeError(item.pos)}}</span>
                  </div>
                  <CButton tabindex="-1" style="width: 20px; height: 20px; padding: 1px;" color="ghost-light" @click="copyAll(item.pos)" square size="sm">
                    <!-- <CIcon style="width:10px; margin: 0px;" name="cil-copy" /> -->
                    <img style="width:15px; height: 15px;" src="../../assets/icons/copy.png" class="imagen" >
                  </CButton>
                  <CButton tabindex="-1" style="width: 20px; height: 20px; padding: 1px; margin-top:15px;" color="warning" v-show="errores.find(fila => fila.pos == item.pos) ? (errores.find(fila => fila.pos == item.pos).fail ? true : false) : false" @click="mostrarPop(item.pos)" square size="sm">
                    <CIcon style="width:10px; margin: 0px;" name="cil-warning" />
                  </CButton>
                </th>
              </template>
              <template #FECHA="{ item }">
                <td :class="buscarError(item.pos)" style="position:relative; padding: 10px 5px 5px 5px;">
                  <div class="d-flex align-items-top flex-wrap flex-sm-nowrap">
                    <input class="form-control fechaInput" type="date" name="fecha"  :id="'fecha'+item.pos" :ref="'fecha'+item.pos">
                    <!-- <input class="form-control fechaInput" :value="item.pos > 8 ? '2021-02-'+(item.pos+1) : '2021-02-0'+(item.pos+1)" type="date" name="fecha"  :id="'fecha'+item.pos" :ref="'fecha'+item.pos"> -->
                    <CButton v-c-tooltip="{
                        content: 'Copiar la fecha en las filas vacías hasta donde haya una fila con información',
                        placement: 'right'
                      }" tabindex="-1" class="buttonClon" @click="clonarInfoRef(item.pos, 'fecha')" color="ghost-light" square size="sm">
                      <img style="width:13px; height: 13px;" src="../../assets/icons/down.png" class="imagen" >
                    </CButton>
                  </div>
                </td>
              </template>
              <template #TRABAJADOR="{ item, index }">
                <td :class="buscarError(item.pos)" style="position:relative; max-width: 180px;">
                  <div class="d-flex align-items-top flex-wrap flex-sm-nowrap gestion" :style="`gap: 5px;${items[index].trabajador?'':' margin-right: 20px;'}`">
                    <MultiSelectC
                      style="flex-grow: 1; height: 1px;"
                      v-model="items[index].trabajador"
                      :options="trabajadores"
                      :multiple="false"
                      selectLabel=""
                      deselectLabel=""
                      label="label"
                      :loading="isLoadingPage"
                      selectedLabel=""
                      @input="inputGetTotales"
                      track-by="label"
                      value-by="id"
                      placeholder="Seleccione una trabajador"
                      :close-on-select="false"
                      :clear-on-select="false"
                      v-c-tooltip="{
                        content: getLabel(items[index]),
                        placement: 'right',
                      }"
                    >
                      <template #no-options>Sin resultados.</template>
                      <template slot="selection" slot-scope="{ values, isOpen }"><span class="multiselect__single" v-if="values.length > 1 && !isOpen">{{ values.length }} ubicaciones</span></template>
                    </MultiSelectC>
                    <CButton v-c-tooltip="{
                        content: 'Copiar el trabajador en las filas vacías hasta donde haya una fila con información',
                        placement: 'right',
                      }" tabindex="-1" class="buttonClon" @click="clonarCelda(index, 'trabajador')" color="ghost-light" square size="sm">
                      <img style="width:13px; height: 13px;" src="../../assets/icons/down.png" class="imagen" >
                    </CButton>
                  </div>
                </td>
              </template>
              <template #ACTIVIDAD="{ item }">
                <td :class="buscarError(item.pos)" style="position:relative">
                 <div class="d-flex align-items-top flex-wrap flex-sm-nowrap">
                      <!-- :options="pruebaActividades" -->
                    <Treeselect
                      style="width: 90%;"
                      v-model="item.actividades"
                      :options="optionsGroup"
                      :show-count="true"
                      :noOptionsText="'Cargando las opciones'"
                      :noChildrenText="'No hay opciones'"
                      placeholder="Selecciona una actividad"
                      :disable-branch-nodes="true"
                      :ref="'actividades'+item.pos"
                      title="Selecciona una actividad"
                      @input="inputGetTotales"
                    >
                      <label slot="option-label" slot-scope="{ node, labelClassName }" :class="labelClassName">
                        <!-- <span v-if="node.isBranch">{{ node.label }}</span> -->
                        <!-- <span style="padding-left: 15px;" v-else> {{ node.label }}</span> -->
                        <span>{{node.label}}</span>
                      </label>
                    </Treeselect>
                    <CButton v-c-tooltip="{
                        content: 'Copiar la actividad en las filas vacías hasta donde haya una fila con información',
                        placement: 'right'
                      }" tabindex="-1" class="buttonClon" @click="clonarCelda(item.pos, 'actividades')" color="ghost-light" square size="sm">
                      <img style="width:13px; height: 13px;" src="../../assets/icons/down.png" class="imagen" >
                    </CButton>
                  </div>
                </td>
              </template>
              <template #TIPO_PAGO="{ item }">
                <td :class="buscarError(item.pos)" style="position:relative;vertical-align: middle;">
                  {{ tipoActividad(item.pos) }}
                </td>
              </template>
              <template #CANTIDAD_P="{ item }">
                <td :class="buscarError(item.pos)" style="position:relative">
                  <div class="form-group row my-2">
                    <input class="form-control" :id="'canProd'+item.pos" v-model="itemVal['canProd'][item.pos]" @input="inputGetTotales" type="number" style="width: 35px; padding: 5px; margin-left: 10px;">
                    <span style=" margin-left: 5px; margin-top: 5px;">{{getUnidad(item.pos)}}</span>
                    <CButton v-c-tooltip="{
                        content: 'Copiar la cantidad en las filas vacías hasta donde haya una fila con información',
                        placement: item.pos == items.length-1 ? 'right-end' : 'right'
                      }" tabindex="-1" class="buttonClon" @click="clonarInfo(item.pos, 'canProd')" color="ghost-light" square size="sm">
                      <img style="width:13px; height: 13px;" src="../../assets/icons/down.png" class="imagen" >
                    </CButton>
                  </div>
                </td>
              </template>
              <template #COSTO_C="{ item }">
                <td :class="buscarError(item.pos)" style="position:relative">
                  <div class="form-group row my-2" v-show="item.actividades != null ? tipoActividad(item.pos) == 'fijo' : false">
                    <input class="form-control" :id="'canPagar'+item.pos" v-model="itemVal['canPagar'][item.pos]" @input="inputGetTotales" type="number" style="width: 35px; padding: 5px; margin-left: 20px;">
                    <span style="margin-left: 5px; margin-top: 5px;">{{getUnidadPagar(item.pos)}}</span>
                    <CButton v-c-tooltip="{
                        content: 'Copiar la cantidad a pagar en las filas vacías hasta donde haya una fila con información',
                        placement: item.pos == items.length-1 ? 'right-end' : 'right'
                      }" tabindex="-1" class="buttonClon" @click="clonarInfo(item.pos, 'canPagar')" color="ghost-light" square size="sm">
                      <img style="width:13px; height: 13px;" src="../../assets/icons/down.png" class="imagen" >
                    </CButton>
                  </div>
                </td>
              </template>
              <template #TIEMPO_EXTRA="{ item }">
                <td :class="buscarError(item.pos)" style="position:relative">
                  <div v-show="item.actividades != null ? tipoActividad(item.pos) == 'fijo' : false">
                    <CSwitch @update:checked="tiempoExtra(item.pos)" :ref="'switch'+item.pos" :id="'switch'+item.pos" class="mx-1" color="primary" variant="3d" />
                  </div>
                  <!-- <CSwitch v-if="item.actividades == null ? true : item.actividades.tipo_pago == 'fijo'" @update:checked="tiempoExtra(item.pos)" class="mx-1" color="primary" variant="3d" /> -->
                </td>
              </template>
              <template #TOTAL_PAGAR="{ item }">
                <td :class="buscarError(item.pos)" style="position:relative; vertical-align: middle; text-align: right;">
                  {{ isNaN(getTotales[item.pos])?getTotales[item.pos]:$formatter(getTotales[item.pos],1) }}
                </td>
              </template>
              <template #UBICACIONES="{ item }">
                <td :class="buscarError(item.pos)" style="position:relative;">
                  <div class="d-flex align-items-top flex-wrap flex-sm-nowrap">
                    <multiselect style="width: 180px; height: 1px;"
                      v-model="item.ubicaciones"
                      :options="ubicaciones"
                      :multiple="true"
                      selectLabel=""
                      deselectLabel=""
                      label="label"
                      :loading="isLoadingPage"
                      selectedLabel=""

                      track-by="label"
                      placeholder="Selecciona una o varias ubicaciones"
                      :close-on-select="false"
                      :clear-on-select="false"
                      title="Selecciona una o varias ubicaciones"
                    >
                      <template #no-options>Sin resultados.</template>
                      <template slot="selection" slot-scope="{ values, isOpen }"><span class="multiselect__single" v-if="values.length > 1 && !isOpen">{{ values.length }} ubicaciones</span></template>
                    </multiselect>
                    <div class="btn-group">
                      <CButton tabindex="-1" @click="obtenerUbicaciones(item.pos)" color="ghost-light" class="buttonUbi btnUbi2" square size="sm">
                        <img style="width:15px; height: 15px;" src="../../assets/icons/file.png" class="imagen" >
                      </CButton>
                    <div class="divUbi">
                      <CButton v-c-tooltip="{
                          content: 'Copiar la ubicación en las filas vacías hasta donde haya una fila con información',
                          placement: item.pos == items.length-1 ? 'left-end' : 'left'
                        }" tabindex="-1" class="buttonClonarUbi" @click="clonarCelda(item.pos, 'ubicaciones')" color="ghost-light" square size="sm">
                        <img style="width:13px; height: 13px;" src="../../assets/icons/down.png" class="imagen" >
                      </CButton>
                    </div>
                    </div>
                  </div>
                </td>
              </template>
              <template #BORRAR="{ item }">
                <td :class="buscarError(item.pos)">
                  <div>
                    <CButton tabindex="-1" style="width: 20px; height: 20px; padding: 1px;" @click="borrarFila(item.pos)" color="ghost-light" square size="sm">
                      <!-- <CIcon style="width:15px; margin: 0px;" name="cil-trash" /> -->
                      <img style="width:15px; height: 15px;" src="../../assets/icons/trash.png" class="imagen" >
                    </CButton>
                  </div>
                </td>
              </template>
            </CDataTable>

              <CCol sm="12" md="9" lg="9">
                <KlayFileDD
                  :fetching="fetching"
                  v-model="medias"
                  :label="`Anexos: `"
                  @onFetch="()=>{fetching=false}"
                  @onErrorFetch="(err)=>{
                    fetching=false;
                    error=err
                    warningModal=true
                  }"
                  :fetchMethod="pushMedia"
                  :baseSrc="$store.getters.MediaGet"
                />
              </CCol>

          </CCardBody>

          <CCardFooter  class="d-flex justify-content-center">
            <router-link :to="{ name: 'Labor', params: { config: config } }">
              <CButton class="px-4 mx-3 btn-lg" color="danger">Cancelar</CButton>
            </router-link>
            <CButton v-if="errores.length > 0 && errores.length < 21" class="px-4 mx-3 btn-lg" color="success">
              <div>
                <div class="w-100 d-flex justify-content-center align-items-center">
                  <div class="sk-flow height-custom flex align-items-center">
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                  </div>
                </div>
              </div>
            </CButton>
            <CButton v-else @click="addLabores()" class="px-4 mx-3 btn-lg" color="success">
              <span>Guardar</span>
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
      <CModal
        size="sm"
        title="Labor"
        :centered="true"
        color="warning"
        :show.sync="warningModal"
      >{{ error }}
      </CModal>
      <CModal
        size="sm"
        title="Cambiando ubicacion raiz"
        :centered="true"
        color="warning"
        :show.sync="rootModal"
        @click="confirmAct"
        @close="cancelAct"
        :no-close-on-backdrop="true"
      >
      <CRow>
        <CCol>
          Al cambiar la ubicación raiz durante la captura, la información del formulario será borrada, desea continuar?
        </CCol>
      </CRow>
      <template #footer>
        <CButton @click="confirmAct" color="success">Aceptar</CButton>
        <CButton @click="cancelAct" color="danger">Cancelar</CButton>
      </template>
      </CModal>
      <CModal
        size="sm"
        title="Labor"
        :centered="true"
        :closeOnBackdrop="false"
        color="info"
        :show.sync="successModal"
        class="text-center"
        >
        <span v-if="errores.length >= 0 && errores.length < 21 || successModalText">
          ¡Un momento, la información se está guardando!.
        </span>
        <span v-else>La información se ha procesado </span>
        <template #footer>
          <CButton v-if="errores.length >= 0 && errores.length < 21 || successModalText" class="px-4 mx-3 btn-lg" color="info">
              <div>
                <div class="w-100 d-flex justify-content-center align-items-center">
                  <div class="sk-flow height-custom flex align-items-center">
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                  </div>
                </div>
              </div>
            </CButton>
            <CButton v-else @click="revisarErrores()" class="px-4 mx-3 btn-lg" color="info">
              <span>Aceptar</span>
            </CButton>
        </template>
      </CModal>
    </CRow>
    <CModal size="lg" :show.sync="modalUbicaciones" :no-close-on-backdrop="true" :centered="false" title="Ubicaciones" color="info">
      <CDataTable
        hover
        bordered
        small
        fixed
        :loading="isLoading"
        :items="filteredItems"
        :fields="fieldsUbi"
        :noItemsView="noItems"
        style="height: 60vmin;"
        class="table-responsive"
      >
        <template #nombre="{item, index}">
          <td v-if="filter" class="py-2 ">
            {{ item.payload.nombre }}
          </td>
          <td
            v-else
            class="py-2"
            :class="
              `${
                ubicacionesJ.filter(hijo => hijo.payload.pertenece_id == item.id)
                  .length > 0
                  ? `cursor-p`
                  : ``
              }`
            "
            @click="toggleUbicaciones(index)"
          >
            <span>
              <CIcon
                v-if="
                  ubicacionesJ.filter(
                    hijo => hijo.payload.pertenece_id == item.id
                  ).length > 0
                "
                name="cil-chevron-circle-down-alt"
              />
            </span>
            {{ item.payload.nombre }}
          </td>
        </template>
        <template #details="{item, index}">
          <CCollapse :show="details.includes(index)">
            <TableCollapse
              :key="posLabor"
              @click-cancel="toggleCancel"
              @click-print="printNanoid"
              :avisar="onResultados"
              :ubicacionPadre="item.id"
              :cultivos="cultivos"
              :ubicaciones="
                ubicacionesJ.filter(hijo => hijo.payload.raiz_id == item.id)
              "
            ></TableCollapse>
          </CCollapse>
        </template>
      </CDataTable>
      <template #footer>
        <CButton @click="agregarUbicaciones()" color="info">Aceptar</CButton>
      </template>
    </CModal>
    <CModal
      size="sm"
      title="Ubicaciones"
      :centered="true"
      color="warning"
      :show.sync="modalUbicacionPadre"
      :closeOnBackdrop="false"
      :fade="true"
      >Tienes una ubicación padre/hijo seleccionada
      <template #footer>
        <CButton @click="modalUbicacionPadre = false" color="warning">Aceptar</CButton>
      </template>
    </CModal>
    <CModal
      size="sm"
      title="Labor"
      :centered="true"
      color="warning"
      :show.sync="successModalLabor"
      >Se limpiara la información de la tabla.
      <template #footer>
        <CButton @click="successModalLabor = false"  color="secondary">Cancelar</CButton>
        <CButton @click="limpiarTabla()"  color="warning">Aceptar</CButton>
      </template>
    </CModal>
    <CModal
      size="sm"
      title="Labor"
      :centered="true"
      color="info"
      :show.sync="modalCopiar"
      >Ya no hay espacios disponibles para poder copiar.
      <template #footer>
        <CButton @click="modalCopiar = false"  color="info">Aceptar</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import MultiSelectC from "../../customComponents/MultiSelectC";
import Multiselect from "vue-multiselect";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
// import "vue-select/dist/vue-select.css";
import moment from "moment";
import Treeselect from '@riophae/vue-treeselect'
import TableCollapse from "../../customComponents/TableCollapse1";
// import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { createPopper } from '@popperjs/core';

const fields = [
  { key: "COPIAR", label: "", _style: "width:1%" },
  { key: "FECHA", label: "Fecha", _style: "width:15%" },
  { key: "TRABAJADOR", label: "Trabajador", _style: "width:20%" },
  { key: "ACTIVIDAD", label: "Actividad", _style: "width:20%" },
  { key: "TIPO_PAGO", label: "Tipo Pago", _style: "width:5%" },
  { key: "CANTIDAD_P", label: "Cantidad producida", _style: "width:5%" },
  { key: "COSTO_C", label: "Cantidad a pagar", _style: "width:15%" },
  { key: "TIEMPO_EXTRA", label: "Tiempo extra", _style: "width:5%" },
  { key: "UBICACIONES", label: "Ubicaciones", _style: "width:20%" },
  { key: "TOTAL_PAGAR", label: "Total", _style: "width:10%" },
  { key: "BORRAR", label: "", _style: "width:1%" },
];
const fieldsUbi = [
  { key: "nombre", label:"Ubicaciones", _style: "width:50%" },
];
export default {
  name: "NuevoLabor",

  components: {
    Multiselect,
    MultiSelectC,
    TableCollapse,

    Treeselect
  },

  data() {
    return {
      iterTotales:null,
      getTotales: new Array(21).fill(0),
      itemVal: {canProd:{},canPagar:{}},
      modalCopiar: false,
      valTree: "",
      tablaLabores: false,
      value: [],
      placement: 'bottom-start',
      nodeCtividad: null,
      hoverM: false,
      errores: [],
      enviado: true,
      ubicacionesJ: [],
      ubicacionesSelec: [],
      posLabor: 0,
      details: [],
      cultivos: [],
      actividades_costos: [],
      items: [],
      noItems: {
        noResults: "Sin Resultados",
        noItems: "Sin Resultados"
      },
      optionsGroup: [],
      pruebaActividades: [{id: 1 ,label: "Cosecha", children:[{id: 2 ,label: "Prueba", children:[{id: 3 ,label: "Prueba1", position: 3}], position: 2}], position: 1}],
      modalUbicaciones: false,
      fields,
      fieldsUbi,
      filter: "",
      dropdownCustom: false,
      allSelections: false,
      modalUbicacionPadre: false,
      date: null,
      multi: null,
      config: this.$route.params.config,
      cantidad: 1,
      cantidadCosto: 1,
      trabajador: null,
      trabajadores: [],
      trabajadoresAll: [],
      categorias: [],
      categoriasAll: [],
      actividad: null,
      actividades: [],
      actividadesAll: [],
      ubicacion: null,
      ubicaciones: [],
      ubicacionesAll: [],
      tiempo_extra: false,
      isFijo: false,
      isLoading: false,
      isLoadingPage: false,
      unidad: "kg",
      unidadPagar: "dia",
      warningModal: false,
      ubicacionRaizOld: {},
      rootModal: false,
      successModalText: false,
      successModal: false,
      successModalLabor: false,
      error: "",
      configurationToggle : true,
      response: false,
      pos: 0,
      fetching: false,
      medias:[],
    };
  },

  mixins: [validationMixin],
  validations: {
    date: {
      required
    },
    cantidad: {
      required,
      notNegative: (value) => value >= 0
    },
    cantidadCosto: {
      required
    }
  },
  computed: {
    getTotal(){
      const refs = this.itemVal
      return(pos)=>{
        let actividad = null
        let trabajador = null
        if(this.items[pos].trabajador){trabajador = this.trabajadoresAll.find(f=>f.id = this.items[pos].trabajador)}
        if (this.items[pos].actividades) { actividad = this.actividadesAll.find(f => f.id === this.items[pos].actividades)}

        if(actividad?.payload?.tipo_pago === 'fijo' && trabajador){
          if(!this.$refs['switch'+pos].state){
            return Number(refs['canPagar'+pos]||0) * trabajador.payload.costo
          }
          else{
            return Number(refs['canPagar'+pos]||0) * trabajador.payload.costo_extra
          }
        }
        if(actividad?.payload?.tipo_pago === 'variable'){
          const actividad_costo = this.actividades_costos.find(f=>f.payload.actividad_id === actividad.id)
          if(!actividad_costo){
            if(!this.errores.find(f=>f.pos===pos&&f.error.message === "Actividad sin costo por ubicación")){
              this.errores.push({pos: pos, error:{message:"Actividad sin costo por ubicación"}, info: this.items[pos], fail:true})
            }
            return 0
          }
          return Number(refs['canProd'+pos]||0) * actividad_costo.payload.costo
        }
        return 0
      }
    },
    isValidDate() {
      return !this.$v.date.$invalid;
    },
    filteredItems() {
      if (this.filter) {
        return this.ubicacionesJ.filter(i =>
          i.payload.nombre.toLowerCase().includes(this.filter.toLowerCase())
        );
      } else {
        return this.ubicacionesJ.filter(i => i.payload.pertenece_id == 0);
        // .filter(i =>
        //   i.payload.nombre.toLowerCase().includes(this.filter.toLowerCase())
        // );
      }
    },
    isValidCantidad() {
      return !this.$v.cantidad.$invalid;
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation;
    },
    ubicacionRaizValue() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    }
  },

  watch: {

    getTotales(newValue, oldValue) {

        const key = moment().format('YYYYMMDDHHmmss')
        console.group(key)
          const oldErrores = this.errores;
          this.errores = []
          newValue.forEach((item, pos)=>{
          console.log(item,oldValue[pos],item!==oldValue[pos])
          if(item === 'error' ){
            return this.errores.push({pos: pos, error:{message:`La actividad no tiene configurado un costo en la ubicación actua: "${this.ubicacionRaiz.label}" `}, info: item, fail:true})
          }

          const oldErr = oldErrores[pos]
          if(typeof oldErr === 'object'){
            if(oldErr.error.message !== `La actividad no tiene configurado un costo en la ubicación actua: "${this.ubicacionRaiz.label}" `){
              return this.errores.push(oldErr)
            }
          }
          return this.errores.push(pos)
        })

        console.groupEnd(key)

    },
    ubicacionRaiz(newValue, oldValue) {
      if(this.items.some(({actividades,fecha,trabajador,ubicaciones,costop,costoc,showpop,})=>actividades||fecha||trabajador||ubicaciones.length>0||costop||costoc||showpop)){
        if(newValue.value!==this.ubicacionRaizOld.value){
          this.rootModal = true
          this.ubicacionRaizOld = oldValue
        }
      }else{
        this.actualizarInfo()
      }
    }
  },

  created() {
    this.$store.dispatch('getNanoid');
    this.isLoadingPage = true;
    document.addEventListener("wheel", function(){
      if(document.activeElement.type === "number"){
        document.activeElement.blur();
      }
    });
    this.makeItems()
    this.$store.dispatch("customHTTP", {
      schema: "configuracion",
      filter: {
        where: [
          {
            field: "payload->parametro",
            value: "modo_calculo_horas_extras",
            operator: "="
          }
        ]
      }
    }).then( (response ) => {
      this.configurationToggle = response.data?.[0]?.payload?.valor === 'auto' ? false : true;
      // response.data[0].payload.valor === 'auto' ? false : this.fields.splice(7,0,{ key: "TIEMPO_EXTRA", label: "Tiempo Extra", _style: "width:10%" });

    }).catch( error  => {
      console.error(error);
    }).finally(() => (this.isLoadingPage = false));
    this.actualizarInfo()
  },

  methods: {
    getLabel(item){
      return item.trabajador?this.trabajadores.find(f=>f.id==item.trabajador).label:'Seleccione una trabajador'
    },
    inputGetTotales(){
      return this.makeGetTotales()
    },

    makeGetTotales(){
      const refs = this.itemVal
      this.getTotales = this.items.map((item,pos)=>{
        let actividad = null
        let trabajador = null
        if(!item.trabajador||!item.actividades){
          return 0
        }
        if(item.trabajador){trabajador = this.trabajadoresAll.find(f=>f.id === item.trabajador)}
        if (item.actividades) { actividad = this.actividadesAll.find(f => f.id === item.actividades)}

        if(actividad?.payload?.tipo_pago === 'fijo' && trabajador){
          if(!this.$refs['switch'+pos].state){
            return Number(refs['canPagar'][pos]||0) * trabajador.payload.costo
          }
          else{
            return Number(refs['canPagar'][pos]||0) * trabajador.payload.costo_extra
          }
        }
        if(actividad?.payload?.tipo_pago === 'variable'){
          const actividad_costo = this.actividades_costos.find(f=>f.payload.actividad_id === actividad.id)
          if(!actividad_costo){
            return 'error'
          }
          return Number(refs['canProd'][pos]||0) * actividad_costo.payload.costo
        }
        return 0
      })
     },
    makeItems(){
      for (let index = 0; index < 21; index++) {
        this.items.push({pos: index, actividades:null, fecha: "" , trabajador:null, ubicaciones: [], costop: "", costoc: "", showpop: false})
        //this.itemVal['canProd'][index] = ""
        //this.itemVal['canPagar'][index] = ""
      }
    },
    confirmAct(){
      this.items=[]
      this.makeItems()
      this.actualizarInfo();
      this.rootModal = false
    },
    cancelAct(){
      this.$store.dispatch("setRootLocation", this.ubicacionRaizOld);
      this.rootModal = false
    },
    async pushMedia(files) {
      const arr = [];

      for (const v of files.map(async (m) => {
        // eslint-disable-next-line no-extra-boolean-cast
        if(!!m.media){
          return Promise.resolve({data:m,status:"success"})
        }
        const formData = new FormData();
        formData.append("media", m);
        const promise = await this.$store.dispatch("customImageHTTP", formData);

        return promise;
      })) {
        const media = await v;

        if (media.status === "success") {
          arr.push(media.data);
        }
      }
      return arr;
      /*
        const formData = new FormData()
        formData.append('media', format.dataURLtoFile(this.fileList[0].thumbUrl))
        this.$store.dispatch('MEDIA_CARGAR', formData)
      */
    },
    revisarErrores() {
      this.successModal = false
      let error = this.errores.find(element => element.fail == true)
      if (!error) {
        this.errores = []
        for (let index = 0; index < this.items.length; index++) {
          //const element = this.items[index];
          this.$refs['fecha'+index].value = ""
          this.itemVal['canProd'][index] = ""
          this.itemVal['canPagar'][index] = ""
          // this.$refs['trabajador'+index]._data._value = null
          this.items[index].trabajador = null
          this.items[index].actividades = null
          this.items[index].ubicaciones = []
        }
      }
    },
    withPopper (dropdownList, component) {
      const popper = createPopper(component.$refs.toggle, dropdownList, {
        placement: this.placement,
        modifiers: [
          {
            name: 'offset', options: {
              offset: [0, -1]
            }
          },
          {
            name: 'toggleClass',
            enabled: true,
            phase: 'write',
            fn ({state}) {
              component.$el.classList.toggle('drop-up', state.placement === 'top')
            },
          }
        ]
      })
      return () => popper.destroy();
    },
    buscarError(item) {
      if (this.errores.find(fila => fila.pos == item)) {
      return this.errores.find(fila => fila.pos == item).fail  ?
        'table-danger' : (this.enviado ? 'table-success' : '')

      }
    },
    mensajeError(item) {
      let error = this.errores.find(el => {
        if (el.pos == item) {
          return el
        }
      })
      let msg = ""
      if (error) {
        if (error.error) {
          switch (error.error.message) {
            case "Los datos dados no eran válidos.":
              msg = "Algunos datos son requeridos"
              break;
            case "El campo fechahora es invalido.":
              msg = "La fecha ingresada es invalida"
              break
            default:
              msg = error.error.message
              break;
          }
        }
      }
      return msg
    },
    mostrarPop(item) {
      this.items[item].showpop = !this.items[item].showpop
    },
    onResultados(datos) {
      let ids = datos.payload.ruta.slice(1,-1).split('/')
      let exist = false;
      ids.forEach(ubicacionId => {
        if (this.ubicacionesSelec.find( ubicacion => ubicacion.value == ubicacionId) && ubicacionId != ids[ids.length - 1]) {
          this.modalUbicacionPadre = true
          exist = true
        }
      });

      if (exist == false) {
        this.ubicacionesSelec.forEach(ubicacion => {
          let ubicacionesRuta = ubicacion.ruta.slice(1,-2).split('/')
          ubicacionesRuta.forEach(ubicacionRuta => {
            if (ubicacionRuta == datos.id) {
              this.modalUbicacionPadre = true
              exist = true
            }
          });
        });
      }

      if (datos.selected && exist == false) {
        if (!this.ubicacionesSelec.find( ubicacion => ubicacion.value == datos.id )) {
          this.ubicacionesSelec.push({value: datos.id, label: datos.payload.nombre, ruta: datos.payload.ruta})
        }
      }else{
        this.ubicacionesSelec = this.ubicacionesSelec.filter(ubicacion => ubicacion.value != datos.id)
      }

    },
    copyAll(item) {
      let espacio = "";
      for (let i = item+1; i < this.items.length; i++) {
        if (this.$refs['fecha'+i].value == "" && this.items[i].actividades == null  && this.items[i].trabajador == null && (this.items[i].ubicaciones == null || this.items[i].ubicaciones.length == 0)) {
          espacio = i
          break
        }
      }
      for (let itemMover = espacio; itemMover > item; itemMover--) {
        if (itemMover-1 == item) {
          this.$refs['fecha'+itemMover].value = this.$refs['fecha'+item].value
          this.items[itemMover].trabajador = this.items[item].trabajador
          this.items[itemMover].actividades = this.items[item].actividades
          this.itemVal['canProd'][itemMover] = this.itemVal['canProd'][item]
          this.itemVal['canPagar'][itemMover] = this.itemVal['canPagar'][item]
          //document.querySelector(`#canPagar${itemMover}`).value = this.itemVal['canPagar'][item]
          this.items[itemMover].ubicaciones = this.items[item].ubicaciones
          if(this.errores.length > 0){
            this.errores[itemMover] = itemMover
          }
        }else{
          this.$refs['fecha'+itemMover].value = this.$refs['fecha'+(itemMover-1)].value
          this.items[itemMover].trabajador = this.items[itemMover-1].trabajador
          this.items[itemMover].actividades = this.items[itemMover-1].actividades
          this.itemVal['canProd'][itemMover] = this.itemVal['canProd'][(itemMover-1)]
          this.itemVal['canPagar'][itemMover] = this.itemVal['canPagar'][(itemMover-1)]
          this.items[itemMover].ubicaciones = this.items[itemMover-1].ubicaciones
          let laborError = this.errores.find(element => element.pos == itemMover-1)
          if (this.errores.length > 0) {
            if (laborError) {
              this.errores[itemMover-1].pos = this.errores[itemMover-1].pos+1
              this.errores[itemMover] = this.errores[itemMover-1]
            }else{
              this.errores[itemMover-1] = this.errores[itemMover-1]+1
              this.errores[itemMover] = this.errores[itemMover-1]
            }
          }
        }
      }
      if (espacio == "") {
        this.modalCopiar = true
      }
    },
    tipoActividad(item) {
      // let tipoPago = ""
      let tipo_pago = ""
      if (this.items[item].actividades) {
        const actSelect = this.actividadesAll.find(
          actividad => actividad.id == this.items[item].actividades
        );

        actSelect ? (tipo_pago = actSelect.payload.tipo_pago) : "";

        return tipo_pago;
      }
    },
    clonarCelda(item, fila) {
      let info = this.items[item][fila]
      for (let index = item+1; index < this.items.length; index++) {
        if (this.items[index][fila] == "" || this.items[index][fila] == null) {
          this.items[index][fila] = info
        }else{
          break;
        }
      }
    },
    clonarInfoRef(item, fila) {
      let inputInfo = this.$refs[fila+item]
      for (let index = item+1; index < this.items.length; index++) {
        let inputNext = this.$refs[fila+index]
        if (inputNext.value != "") {
          break;
        }

          inputNext.value = inputInfo.value

      }
    },
    clonarInfo(item, fila) {
      for (let index = item+1; index < this.items.length; index++) {
        if (this.itemVal[fila][index] !== "" && this.itemVal[fila][index] !== undefined) {
          break;
        }
        if (fila == "canPagar") {
          if (this.tipoActividad(index) == 'fijo') {
            this.itemVal[fila][index] = this.itemVal[fila][item]
            document.querySelector(`#${fila}${item}`).value = this.itemVal[fila][item]
          }
        }else{
          this.itemVal[fila][index] = this.itemVal[fila][item]
          document.querySelector(`#${fila}${item}`).value = this.itemVal[fila][item]
        }
      }
      this.$forceUpdate();
      this.makeGetTotales()
    },
    borrarFila(item) {
      this.items[item].actividades = null
      this.items[item].ubicaciones = []
      this.$refs['fecha'+item].value = ""
      this.itemVal['canProd'][item] = ""
      this.itemVal['canPagar'][item] = ""
      this.items[item].trabajador = null
      for (let index = 0; index < this.errores.length; index++) {
        if (item == 0) {
          if (this.errores[index].pos == 0) {
            this.errores[index] = item
            break
          }
        }
        if (this.errores[index].pos) {
          if (this.errores[index].pos == item) {
            this.errores[index] = item
            break
          }
        }
      }
    },
    limpiarTabla() {

      this.successModalLabor = false
      this.errores = []
      this.pos = 0
      for (let index = 0; index < this.items.length; index++) {
        this.items[index].actividades = null
        this.items[index].ubicaciones = []
        this.$refs['fecha'+index].value = ""
        this.itemVal['canProd'][index] = ""
        this.itemVal['canPagar'][index] = ""
        this.items[index].trabajador = null
      }
    },
    agregarUbicaciones() {
      this.items[this.posLabor].ubicaciones = this.ubicacionesSelec
      this.modalUbicaciones = false
      this.$store.dispatch('updateStatus', true)
      this.ubicacionesSelec = []
      this.details = []
    },
    obtenerUbicaciones(item) {
      this.$store.dispatch('updateStatus', false)
      // this.details = []
      this.modalUbicaciones = true
      this.posLabor = item
      this.$store.state.count = []
    },
    toggleUbicaciones(index) {
      const position = this.details.indexOf(index);
      position !== -1
        ? this.details.splice(position, 1)
        : this.details.push(index);
    },
    printNanoid(ubicacion, cant) {

      if (ubicacion && cant && cant > 0) {
        window.printTicket(
          `^XA^CFA,25^FO25,165^FD${ubicacion.payload.nombre}^FS^FO20,20^BY3^BCN,100,Y,N, ^FD${ubicacion.payload.nanoid}^PQ${cant}^XZ`
        );
      }
      //window.printTicket(`^XA^FO20,20^BY3^BCN,100,Y,N,N^FDUb03b201^XZ`);
    },
    toggleCancel(index, item) {
      this.cancelModal = true;
      const itemIndex = {
        id: item.id,
        name: item.payload.nombre,
        index: this.items.indexOf(item)
      };
      this.itemModal = itemIndex;
    },
    getUnidadLabor() {
      if (this.actividad) {
        // let tipo_pago = "";
        const actSelect = this.actividadesAll.find(
          actividad => actividad.id == this.actividad.id
        );
        return actSelect ? ` (${actSelect.payload.unidad})` : "";
      }
      return "";
    },
    getUnidadPagarLabor() {
      if (this.actividad && this.trabajador) {
        let tipo_pago = "";
        const actSelect = this.actividadesAll.find(
          actividad => actividad.id == this.actividad.id
        );
        actSelect ? (tipo_pago = actSelect.payload.tipo_pago) : "";

        if (tipo_pago.toLowerCase() == "fijo") {
          const trabSelect = this.trabajadoresAll.find(
            trabajador => trabajador.id == this.trabajador.value
          );
          if (trabSelect) {
            return this.tiempo_extra
              ? ` (${trabSelect.payload.unidad_extra})`
              : ` (${trabSelect.payload.unidad})`;
          }
        }
      }
      return "";
    },
    getUnidad(item) {
      if (this.items[item].actividades) {
        const actSelect = this.actividadesAll.find(
          actividad => actividad.id == this.items[item].actividades
        );
        return actSelect ? ` ${actSelect.payload.unidad}` : "";
      }
      return "";
    },
    getUnidadPagar(item) {
      if (this.items[item].actividades && this.items[item].trabajador) {
        let tipo_pago = "";
        let tiempo_Extra = this.$refs['switch'+item].state
        const actSelect = this.actividadesAll.find(
          actividad => actividad.id == this.items[item].actividades
        );
        actSelect ? (tipo_pago = actSelect.payload.tipo_pago) : "";

        if (tipo_pago.toLowerCase() == "fijo") {
          const trabSelect = this.trabajadoresAll.find(
            trabajador => trabajador.id == this.items[item].trabajador
          );
          if (trabSelect) {
            return tiempo_Extra
              ? ` ${trabSelect.payload.unidad_extra}`
              : ` ${trabSelect.payload.unidad}`;
          }
        }
      }
      return "";
    },
    tiempoExtra() {
      // console.log(this.$refs['switch'+item].state)
      this.inputGetTotales()
    },
    filtrarActividad() {
      if (this.actividad) {
        // console.log();
        const actSelect = this.actividadesAll.find(
          actividad => actividad.id == this.actividad.id
        );
        // console.log(this.actividadesAll);
        // console.log(this.actividad);
        // console.log(actSelect);
        actSelect.payload.tipo_pago.toLowerCase() === "fijo"
          ? (this.isFijo = true)
          : (this.isFijo = false);
      }
    },
    actualizarInfo() {
      this.isLoadingPage = true;
      const ubi = [
        this.$store.dispatch("customHTTP", {
          schema: "actividades_costos",
          filter: {
            where: [
              {
                field: "payload->ubicacion_id",
                operator: "regexp",
                value: `[[:<:]]${this.ubicacionRaizValue}[[:>:]]`
              }
            ]
          },
          order: [
            {
              field: "payload->nombre",
              direction: "asc"
            }
          ],
        }),
        this.$store.dispatch("customHTTP", {
          schema: "trabajadores",
          filter: {
            where: [
              {
                field: "payload->ubicaciones",
                operator: "regexp",
                value: `[[:<:]]${this.ubicacionRaizValue}[[:>:]]`
              },
              {
                  field: "payload->suspendido",
                  operator: "=",
                  value: false
              }
            ]
          },
          order: [
            {
              field: "payload->nombre",
              direction: "asc"
            }
          ],
        }),
        this.$store.dispatch("customHTTP", {
          schema: "actividades",
          order: [
            {
              field: "payload->pertenece_id",
              direction: "asc"
            }
          ],
          _filter: {
            where: [
              {
                field: "payload->unidad",
                value: "",
                operator: "!="
              }
            ]
          }
        })
      ];

      if (this.ubicacionRaizValue) {
        ubi.push(this.$store.dispatch("customHTTP", {
        schema: "ubicaciones",
        filter: {
          where: [
            {
              field: "payload->raiz_id",
              value: this.ubicacionRaizValue,
              operator: "="
            },
            {
              field: "payload->suspendido",
              value: false,
              operator: "="
            }
          ]
        },
        order:[{
          field: 'payload->nombre',
          direction: 'asc'
        }]
      }));
      } else {
        ubi.push(this.$store.dispatch("customHTTP", {
          schema: "ubicaciones",
          filter: {
            where: [
              {
                field: "payload->suspendido",
                value: false,
                operator: "="
              }
            ],
          },
          order:[{
            field: 'payload->nombre',
            direction: 'asc'
          }]
        }));
      }

      Promise.all(ubi)
        .then(([actividades_costos, trabajadores, actividades, ubicaciones]) => {
          this.actividades_costos = actividades_costos.data
          this.trabajadores = trabajadores.data.map(trabajador => {
            return { id: trabajador.id, label: trabajador.payload.nombre };
          }).sort((a,b)=>a.label.localeCompare(b.label));
          this.actividades = actividades.data.map(actividad => {
            return { id: actividad.id, label: actividad.payload.nombre, unidad: actividad.payload.unidad};
          }).sort((a,b)=>a.label.localeCompare(b.label));

          this.ubicaciones = ubicaciones.data.map(ubicacion => {
            return { value: ubicacion.id, label: ubicacion.payload.nombre };
          });

          this.ubicacionesJ = ubicaciones.data
              ? ubicaciones.data.map(ubi => {
                  return { ...ubi, selected: false };
                })
              : [];

          function clearDeep(item){
            if(item.children.length){
              item.children=item.children.map(clearDeep)
            } else{
              delete item.children
            }
            return item
          }
          this.optionsGroup = actividades.data
          .sort((a,b)=> a.payload.ruta.split('/').length-b.payload.ruta.split('/').length || a.payload.nombre.localeCompare(b.payload.nombre))
          .reduce((v,c)=>{
            c.payload.ruta
            .split('/').slice(1,-2).map(Number)
            .reduce((pointer,id)=>pointer.find(f=>f.id===id).children,v)
            .push({
              id: c.id,
              label: c.payload.nombre,
              tipo_pago: c.payload.tipo_pago,
              tipo: c.payload.tipo,
              children: [],
            })
            return v
          }, [])
          .map(clearDeep)

          this.ubicacionesAll = ubicaciones.data;
          this.trabajadoresAll = trabajadores.data;
          this.actividadesAll = actividades.data.sort((a,b)=>a.payload.nombre.localeCompare(b.payload.nombre));
        })
        .finally(() => (this.isLoadingPage = false));
    },
    buscarRama(actividad, arrayRama) {
      for (let actHoja = 0; actHoja < arrayRama.length; actHoja++) {
        const actRaiz = arrayRama[actHoja];
        let actRama = actRaiz.children ? actRaiz.children.find(element => element.id == actividad.payload.pertenece_id) : false
        if (actRama) {
          actRama.children ? actRama.children.push({id: actividad.id ,label: actividad.payload.nombre, tipo_pago: actividad.payload.tipo_pago, tipo: actividad.payload.tipo}) : actRama.children = [{id: actividad.id ,label: actividad.payload.nombre, tipo_pago: actividad.payload.tipo_pago, tipo: actividad.payload.tipo}]
          break
        }else{
          if (arrayRama[actHoja].children) {
            this.buscarRama(actividad, arrayRama[actHoja].children)
          }
        }
      }
    },
    async addLabores() {
      // this.errores = []
      this.enviado = false;
      this.successModal = true;
      this.successModalText = true;
      console.log(this.items)

      this.fetching = true
      this.isLoading = true;

      await (new Promise((res)=>{
        const iter = setInterval(()=>{
          console.log(this.fetching)
          if(!this.fetching){
            this.error = ""
            clearInterval(iter)
            res()
          }
        },1000)
      }))
      this.isLoading = false;
      if(this.error){
        this.successModal = false;
        return
      }
      this.successModal = true;
      this.agregarLabor()
      this.enviado = true
      this.isLoading = false;
    },
    agregarLabor(){
      if (this.pos < this.items.length) {
        let labor = this.items[this.pos]
        let newDate = moment(this.$refs['fecha'+labor.pos].value, "YYYY-MM-DD HH:mm:ss");
        let laborError = this.errores.find(element => element.pos == labor.pos)
        this.pos = this.pos +1
        if (laborError) {
          if (laborError.fail) {
            this.errores = this.errores.filter(el => el.pos != labor.pos )
            if (newDate != "" || labor.actividades != null || labor.trabajador != null || labor.ubicaciones.length > 0) {
              if (this.itemVal['canProd'][labor.pos] != "" || this.itemVal['canProd'][labor.pos] != 0) {
                const laborRequest = this.$store.dispatch("customDocumentoAddHTTP",
                this.tipoActividad(labor.pos) == 'fijo' ?{
                  schema: "labores",
                  payload: {
                    encabezado: {
                      fechahora: newDate.format("YYYY-MM-DD HH:mm:ss"),
                      // trabajador_id: this.$refs['trabajador'+labor.pos]._data._value.value ? this.$refs['trabajador'+labor.pos]._data._value.value : "",
                      trabajador_id: labor.trabajador ? labor.trabajador : null,
                      actividad_id: labor.actividades ? labor.actividades : null,
                      tiempo_extra: this.$refs['switch'+labor.pos].state,
                      cantidad: Number(this.itemVal['canProd'][labor.pos]),
                      ubicaciones: labor.ubicaciones ? labor.ubicaciones.map( ubicacion => {
                        return ubicacion.value
                      }) : false,
                      cantidad_costo: Number(this.itemVal['canPagar'][labor.pos]),
                      ubicacion_raiz_id: this.ubicacionRaiz
                        ? this.ubicacionRaiz.value
                        : null
                    },
                    anexos: this.medias,
                  }
                }:{
                  schema: "labores",
                  payload: {
                    encabezado: {
                      fechahora: newDate.format("YYYY-MM-DD HH:mm:ss"),
                      trabajador_id: labor.trabajador ? labor.trabajador : null,
                      actividad_id: labor.actividades ? labor.actividades : null,
                      tiempo_extra: false,
                      cantidad: Number(this.itemVal['canProd'][labor.pos]),
                      ubicaciones: labor.ubicaciones ? labor.ubicaciones.map( ubicacion => {
                        return ubicacion.value
                      }) : false,
                      ubicacion_raiz_id: this.ubicacionRaiz
                        ? this.ubicacionRaiz.value
                        : null
                    },
                    anexos: this.medias,
                  }
                });

                laborRequest.then(msg => {
                  this.errores.push({pos: labor.pos, error: msg, info: labor, fail:false})
                  this.agregarLabor()
                }).catch( msg => {
                  this.errores.push({pos: labor.pos, error: msg, info: labor, fail:true})
                  this.agregarLabor()
                }).finally(() => {
                })
              }else{
              this.errores.push({pos: labor.pos, error: { message: "No se ingreso cantidad" }, info: labor, fail:true})
              this.agregarLabor()
              }
            }
          }else{
            this.errores = this.errores.filter(el => el.pos != labor.pos )
            this.errores.push({pos: labor.pos, error: "", info: labor, fail:false})
            this.agregarLabor()
          }
        }else{
          this.errores = this.errores.filter(el => el != labor.pos )
          if (this.$refs['fecha'+labor.pos].value != "" || labor.actividades != null || labor.trabajador != null || labor.ubicaciones.length > 0) {
            if (this.itemVal['canProd'][labor.pos] != "" || this.itemVal['canProd'][labor.pos] != 0) {
              const laborRequest = this.$store.dispatch("customDocumentoAddHTTP",
              this.tipoActividad(labor.pos) == 'fijo' ? {
                schema: "labores",
                payload: {
                  encabezado: {
                    fechahora: newDate.format("YYYY-MM-DD HH:mm:ss"),
                    trabajador_id: labor.trabajador ? labor.trabajador : null,
                    actividad_id: labor.actividades ? labor.actividades : null,
                    tiempo_extra: this.$refs['switch'+labor.pos].state,
                    cantidad: Number(this.itemVal['canProd'][labor.pos]),
                    ubicaciones: labor.ubicaciones ? labor.ubicaciones.map( ubicacion => {
                      return ubicacion.value
                    }) : false,
                    cantidad_costo: Number(this.itemVal['canPagar'][labor.pos]),
                    ubicacion_raiz_id: this.ubicacionRaiz
                      ? this.ubicacionRaiz.value
                      : null,
                  },
                    anexos: this.medias,
                }
              }
              :{
                schema: "labores",
                payload: {
                  encabezado: {
                    fechahora: newDate.format("YYYY-MM-DD HH:mm:ss"),
                    trabajador_id: labor.trabajador ? labor.trabajador : null,
                    actividad_id: labor.actividades ? labor.actividades : null,
                    tiempo_extra: false,
                    cantidad: Number(this.itemVal['canProd'][labor.pos]),
                    ubicaciones: labor.ubicaciones ? labor.ubicaciones.map( ubicacion => {
                      return ubicacion.value
                    }) : false,
                    ubicacion_raiz_id: this.ubicacionRaiz
                      ? this.ubicacionRaiz.value
                      : null,
                  },
                    anexos: this.medias,
                }
              });

              laborRequest.then(msg => {
                this.errores.push({pos: labor.pos, error: msg, info: labor, fail:false})
                this.agregarLabor()
              }).catch( msg => {
                this.errores.push({pos: labor.pos, error: msg, info: labor, fail:true})
                this.agregarLabor()
              }).finally(() => {
              })
            }else{
              this.errores.push({pos: labor.pos, error:{message:"No se ingreso cantidad"}, info: labor, fail:true})
              this.agregarLabor()
            }

          }else{
            let item = this.errores.find(el => el === labor.pos)
            if (item == 0) {
              this.agregarLabor()
            }else if (!item) {
              this.errores.push(labor.pos)
              this.agregarLabor()
            }else{
              this.agregarLabor()
            }
          }
        }
      }else{
        const renglonesConInfo = this.errores.filter(ff=>typeof ff !== "number")

        if(!!renglonesConInfo.length&&renglonesConInfo.every(e=>!e.fail)){
          this.medias = []
        }
        this.pos = 0
        this.successModalText = false;
      }
    },
    validateUbicacion() {
      if (this.multi) {
        const newUbicaciones = this.multi.map(ubi => {
          return ubi.value;
        });
        return newUbicaciones;
      } else {
        return null;
      }
    },
    checkIfValid(fieldName) {
      const field = this.$v[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    validateLabor() {
      this.$v.date.$touch();
      this.$v.cantidad.$touch();
      this.isFijo ? this.$v.cantidadCosto.$touch() : "";
      // this.$v.equivalencia_6oz.$touch();
    }
  }
};
</script>

<style src="../../assets/scss/multiselect.css"></style>
<style src="../../assets/scss/vue-select.css"></style>
<!-- <style src="vue-multiselect/dist/vue-multiselect.min.css"></style>-->
<style src="../../assets/scss/tree-select.css"></style>
<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.fechaInput{
  width: 90%;
  padding: 2px;
}
.selectFit{
  overflow: hidden;
  text-overflow: ellipsis !important;
  white-space: nowrap;
  padding-left: 0%;
}
input[type="date"]::-webkit-calendar-picker-indicator {
    position: absolute;
    /* top: 3px; */
    /* right: 12px; */
    right: 10%;
    z-index: 1;
    color: black;
    opacity: 1;
}
.v-select.drop-up.vs--open .vs__dropdown-toggle {
  border-radius: 0 0 4px 4px;
  border-top-color: transparent;
  border-bottom-color: rgba(60, 60, 60, 0.26);
}
[data-popper-placement='bottom-start'] {
  border-radius: 4px 4px 0 0;
  border-top-style: solid;
  border-bottom-style: none;
  box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.15)
}
td{
  position:relative; padding: 10px 5px 5px 5px;
}
.popUp{
  position:absolute;
  display: block;
  width: 300px;
  z-index: 2;
  background-color: rgb(255, 0, 0);
  border-radius: 10px;
  color: white;
  padding: 10px;
  margin-left: 35%;
  margin-top: 20px;
}
.buttonClon{
  width:15px;
  height:15px;
  z-index: 1;
  padding-left: 0%;
  padding-top: 0%;
  padding-right: 0%;
  padding-bottom: 10px;
  /* position:absolute;  */
  /* bottom: 20%;  */
  top: 30px;
  left: 90%;
  /* display: block !important; */
}
.btnUbi2{
  /* border-left: 0ch; */
  border:0ch;
  top: 8px;
  z-index: 2;
}
.buttonUbi{
  width:17px;
  height:17px;
  z-index: 1;
  padding-left: 0%;
  padding-top: 0%;
  padding-right: 0%;
  padding-bottom: 0%;
  /* display: block !important; */
}
.buttonClonarUbi{
  width:15px;
  height:15px;
  z-index: 1;
  padding-left: 0%;
  padding-top: 0%;
  padding-right: 0%;
  padding-bottom: 5px;
  /* left: 85%; */
  /* display: block !important; */
}
.divUbi{
  width: 40px;
  position:absolute;
  bottom:0;
  /* left:90%;
  bottom: 20%;  */
  z-index: 2;
  /* right: 10px; */
  display: inline !important;
}
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] { -moz-appearance:textfield; }
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.margin-multi {
  margin-bottom: 1rem !important;
}
.bg-load-white {
  background-color: white !important;
}
.height-custom {
  height: 25px;
}
.cursor-p {
  cursor: pointer;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 8px;
    padding-right: 8px;
  }
  .text-sm {
    font-size: 16px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}

</style>
